import AccountHolderView from "../account-holder-view";


function AccountHolderCanceledView() {
  return <AccountHolderView isCancelledPrograms />
}
export default AccountHolderCanceledView;
